const validate = require("validate.js");
const Cropper = require('cropperjs');
const axios = require('axios');

export default class ProfileImage {
  constructor(args) {
    console.log('profile_edit_image.js loaded');

    // Form validation
    let constraints = {
      'uploaded_file[photo]': {
        presence: {
          message: "画像を選択してください"
        }
      }
    };

    let cropper = false;
    let inputFile = document.getElementById("uploaded_file_photo");

    // Hook up the form so we can prevent it from being posted
    let form = document.getElementById("profile_image_form");
    form.onsubmit = function (ev) {
      ev.preventDefault();
      handleFormSubmit(form);
    }

    inputFile.onchange = function(elem) {
      let input = elem.target;

      if(cropper !== false) {
        cropper.destroy();
      }
      if (input.files[0].size <= 700000) {
        document.getElementById('image_error').classList.remove('show');
        document.getElementById('image_error_inner').innerHTML = "";

        let fileName = input.files[0].name;
        if (input.files && input.files[0]) {
          let reader = new FileReader();

          reader.onload = function (e) {
            document.getElementById('image_crop').setAttribute('src', e.target.result);
            document.getElementById('image_name').innerHTML = fileName;

            let image_crop = document.getElementById('image_crop');
            cropper = new Cropper(image_crop, {
              autoCrop: true,
              rotatable: false,
              zoomOnWheel: false,
              aspectRatio: 1 / 1,
              // background: false,
              preview: '#image_preview',
              crop: function(e) {
                const cropedForm = document.forms.profile_image_form;
                cropedForm.x1.value = e.detail.x;
                cropedForm.y1.value = e.detail.y;
                cropedForm.w.value = e.detail.width;
                cropedForm.h.value = e.detail.height;
                cropedForm.x2.value = e.detail.scaleX;
                cropedForm.y2.value = e.detail.scaleY;
                // console.log('x1', e.detail.x);
                // console.log('y1', e.detail.y);
                // console.log('w', e.detail.width);
                // console.log('h', e.detail.height);
                // console.log('x2',e.detail.scaleX);
                // console.log('y2',e.detail.scaleY);
              }
            });
            document.getElementById('image_preview').classList.add('show');
          }

          // console.log(reader.readAsDataURL(input.files[0]));
          reader.readAsDataURL(input.files[0]);
        }
      } else {
        document.getElementById('image_error').classList.add('show');
        document.getElementById('image_error_inner').innerHTML = "画像は700kb以下のjpg、pngファイルを選択してください。";
      }
    }


    function handleFormSubmit(form, input) {
      // validate the form against the constraints
      let errors = validate(form, constraints, {fullMessages: false});
      // then we update the form to reflect the results
      showErrors(form, errors || {});
      if (!errors) {
        showSuccess();
      }
    }

    // Updates the inputs with the validation errors
    function showErrors(form, errors) {
      // We loop through all the inputs and show the errors for that input
      form.querySelectorAll(".input_validate").forEach(function(input) {
        // Since the errors can be null if no errors were found we need to handle that
        showErrorsForInput(input, errors && errors[input.name]);
      });
    }

    // Shows the errors for a specific input
    function showErrorsForInput(input, errors) {
      // This is the root of the input
      let formGroup = closestParent(input.parentNode, "form-group")
        // Find where the error messages will be insert into
      let messages = formGroup.querySelector(".error-messages");
      // First we remove any old messages and resets the classes
      resetFormGroup(formGroup,messages);
      // If we have errors
      if (errors) {
        // we first mark the group has having errors
        formGroup.classList.add("has-error");
        // then we append all the errors
        errors.forEach(function(error) {
          addError(messages, error);
        });
      } else {
        // otherwise we simply mark it as success
        formGroup.classList.add("has-success");
      }
    }

    // Recusively finds the closest parent that has the specified class
    function closestParent(child, className) {
      if (!child || child == document) {
        return null;
      }
      if (child.classList.contains(className)) {
        return child;
      } else {
        return closestParent(child.parentNode, className);
      }
    }

    function resetFormGroup(formGroup,messages) {
      // Remove the success and error classes
      formGroup.classList.remove("has-error");
      formGroup.classList.remove("has-success");
      messages.classList.remove("show");
      // and remove any old messages
      // _.each(formGroup.querySelectorAll(".help-block.error"), function(el) {
      //   el.parentNode.removeChild(el);
      // });
      formGroup.querySelectorAll(".help-block.error").forEach(function(element) {
        element.parentNode.removeChild(element);
      });

    }

    // Adds the specified error with the following markup
    // <p class="help-block error">[message]</p>
    function addError(messages, error) {
      let block = document.createElement("p");
      block.classList.add("help-block");
      block.classList.add("error");
      block.innerText = error;
      messages.appendChild(block);
      messages.classList.add("show");
    }

    function showSuccess() {
      let croppedOption = cropper.canvasData
      croppedOption.maxWidth = 4096;
      croppedOption.maxHeight = 4096;
      croppedOption.imageSmoothingEnabled = false;
      croppedOption.imageSmoothingQuality = 'high';

      var croppedCanvas = cropper.getCroppedCanvas(croppedOption);
      if(croppedCanvas.toBlob){
        croppedCanvas.toBlob(function (blob) {
          uploadTmpImage(blob);
        });
      }else if(croppedCanvas.msToBlob){
        var blob = croppedCanvas.msToBlob();
        uploadTmpImage(blob);
      }

    }

    function uploadTmpImage(blob) {
      // console.log(blob);
      var formData = new FormData();
      formData.append('croppedImage', blob);
      formData.append('authenticity_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
      axios.post('/profile/upload_tmp_face_image',  formData,
      {headers: {'content-type': 'multipart/form-data'}}).then(function (response) {
        location.href="/profile";
      })['catch'](function (error) {
      });
    }

  }

  // methods
}



// WEBPACK FOOTER //
// ./pages/profile_edit_image.js